import { render, staticRenderFns } from "./realEstates.vue?vue&type=template&id=29953c0f&scoped=true&"
import script from "./realEstates.vue?vue&type=script&lang=js&"
export * from "./realEstates.vue?vue&type=script&lang=js&"
import style0 from "./realEstates.vue?vue&type=style&index=0&id=29953c0f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29953c0f",
  null
  
)

export default component.exports